export default {"src":"/_next/static/media/loanrefinancecalc.12d4d486.svg","height":430,"width":430,"blurWidth":0,"blurHeight":0};